import firebase from 'firebase';
import '@firebase/auth';
import '@firebase/firestore';
import '@firebase/storage';
import '@firebase/functions';
import "@firebase//analytics";
import '@firebase/app-check'
import '@firebase/messaging';
// const messaging = firebase.messaging();
//live
const firebaseConfig = {
    apiKey: process.env.REACT_APP_GOOGLE_API,
    authDomain: "metadoc-app.firebaseapp.com",
    projectId: "metadoc-app",
    storageBucket: "metadoc-app.appspot.com",
    messagingSenderId: "809013643436",
    appId: "1:809013643436:web:a6463fd1dec16aa251f709",
    measurementId: "G-YQTFPK7T87"
};
//test
// const firebaseConfig = {
//     apiKey: "AIzaSyD4HeHWcoIgd9QYqVq3A9wAnhD8tEBMIR4",
//     authDomain: "metadoc-dev.firebaseapp.com",
//     projectId: "metadoc-dev",
//     storageBucket: "metadoc-dev.appspot.com",
//     messagingSenderId: "775059749917",
//     appId: "1:775059749917:web:5cef3e130da4ae419f9af4",
// };
let firestore;
let auth;
let storage;
let messaging;
let functions;
let analytics;
let appCheck;

if (!firebase.apps.length) {
    let app = firebase.initializeApp(firebaseConfig);
    firebase.analytics(app)
    const appCheck = firebase.appCheck();
    appCheck.activate('6LcEq3YqAAAAAJHdo7O4F0II6hqDREshp7SjK0Al', true)
    firestore = firebase.firestore
    functions = firebase.functions

    auth = firebase.auth
    storage = firebase.storage
    messaging = firebase.messaging
    analytics = firebase.analytics
}

export { firestore, auth, storage, messaging, functions, analytics, appCheck };

